







































































import Vue from 'vue';

import store from '@/store';
import { AuthStatus } from '@/store/auth';
import {
  renderSignInButton,
  SignInResponse,
  SignInText
} from '@/api/auth/google';

export default Vue.extend({
  name: 'Login',

  props: {
    targetUrl: {
      type: String,
      default: '/'
    },
    token: {
      type: String,
      default: ''
    }
  },

  computed: {
    user: () => store.state.auth.user,
    isAuthenticated: () => store.state.auth.isAuthenticated,
    status: () => store.state.auth.authStatus,
    failedEmail: () => store.state.auth.failedEmail,
    showSpinner() {
      return this.status === AuthStatus.IN_PROGRESS;
    },
    showError() {
      return this.status === AuthStatus.FAILURE;
    },
    showEnableCookies() {
      return this.status === AuthStatus.COOKIES_DISABLED;
    }
  },

  methods: {
    signInWithGoogle: (response: SignInResponse) => {
      store.dispatch.auth.loginWithGoogle(response.idToken);
    },

    signInWithMicrosoft: () => {
      store.dispatch.auth.loginWithMicrosoft();
    }
  },

  watch: {
    isAuthenticated(current, previous) {
      const nextUrl = this.targetUrl === '/' ? '/secure/orgs' : this.targetUrl;

      if (current && current !== previous) {
        this.$router.push(nextUrl);
      }
    }
  },

  mounted() {
    if (this.token) {
      store.dispatch.auth.signInWithAccessToken(this.token);
    }
    if (!this.token || this.showError) {
      renderSignInButton(
        this.$refs.googleLoginButton,
        SignInText.signInWith,
        this.signInWithGoogle
      );
    }
  }
});
